import { Controller } from "@hotwired/stimulus"
import "codemirror"
import "codemirror/modes/htmlmixed"
import "codemirror/modes/javascript"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { remove_flash, hide_messages, check_auth_status, scrollToContainer, dataTruncate } from "lib/helpers"

// custom_classes/index.haml  data-controller="custom-classes--index"
export default class extends Controller {
  static values = {
    aclForbidden: Number,
    aclOpen: Number,
    aclGroups: Number,
    aclIds: Number,
    aclOwner: Number,
    classId: String,
    className: String,
    customClassesPath: String,
    usersEditPath: String,
    removeDataPath: String,
    fileSizeLimit: Number,
    fileSizeLimitMb: Number,
  }

  connect() {
    this.editCodem = null
    this.addCodem = null
    this.oTable = null
    this.fieldCounter = 1

    this.#bindPermissionsAccessSelectors()
    this.#bindMainPage()
  }

  disconnect() {
    if (this.oTable) {
      this.oTable = destroyTurboDataTable(this.oTable)
    }
    if (this.editCodem) {
      this.editCodem.toTextArea()
      this.editCodem = null
    }
    if (this.addCodem) {
      this.addCodem.toTextArea()
      this.addCodem = null
    }

    this.#unbindAjaxForms()

    $(".modal").off("hide.bs.modal.customClassesIndex")
    $("#confirmation_remove_class").off("shown.bs.modal.customClassesIndex")
    $(".form-results-errors .close").off("click.customClassesIndex")
    $("#new_custom_class_dialog, #field_add_dialog").find("input:submit").off("click.customClassesIndex")
    $("#record_add_dialog, #record_edit_dialog").off(".customClassesIndex")
    $("#record_add_dialog #set_permissions, #record_edit_dialog #set_permissions").off("click.customClassesIndex")
    $("#simple_add, #advanced_add, #simple_edit, #advanced_edit").off("click.customClassesIndex")
    $("#permissions_create_access, #permissions_read_access, #permissions_update_access, #permissions_delete_access").off("change.customClassesIndex")
    $(".new-btn").off("mouseup.customClassesIndex")

    $(".class_select #class_name").off("change.customClassesIndex")
    $(".inputFile:not(.import_csv)").off("change.customClassesIndex")
    $(this.element).off("input.customClassesIndex", "#custom_table_filter input")
    $(this.element).off("autocompleteselect.customClassesIndex", "#custom_table_filter input")

    this.#destroyCheckboxDelegation()

    this.fieldCounter = 1
  }

  // -- Actions (wired via data-action in HAML) --------------------------------

  addNewField() {
    const newField = $(".new_custom_field").last().clone()
    newField.insertAfter("div.new_custom_field:last")
    const customCheckbox = newField.find(".custom-checkbox")
    const checkboxId = `custom_field__is_array_${this.fieldCounter}`

    newField.attr("id", `label_check_${this.fieldCounter}`)
    customCheckbox.attr({ id: checkboxId, name: "custom_field[][is_array]" })
    newField.find("label").attr("for", checkboxId)
    customCheckbox.prop("checked", false)

    const type = newField.find("select").val()
    if (type === "File" || type === "Location" || type === "Date") {
      customCheckbox.parent().hide()
    } else {
      customCheckbox.parent().show()
    }

    newField.find("select").change(function () {
      if ($(this).val() === "File" || $(this).val() === "Location" || $(this).val() === "Date") {
        customCheckbox.prop("checked", false)
        customCheckbox.parent().hide()
      } else {
        customCheckbox.parent().show()
      }
    }).change()

    this.fieldCounter++
    $("#remove_button").removeAttr("disabled")

    if ($(".new_custom_field").length > 64) {
      $("#add_button").attr("disabled", true)
    }
  }

  removeField() {
    $(".new_custom_field").last().remove()
    $("#add_button").removeAttr("disabled")
    if ($(".new_custom_field").length === 1) {
      $("#remove_button").attr("disabled", true)
    }
  }

  openAddDialog(event) {
    event.preventDefault()

    $(".new_custom_field:first").siblings(".new_custom_field").remove()
    $("#add_button").removeAttr("disabled").next().attr("disabled", true)
    $("#new_custom_class_dialog input:text").each(function () {
      $(".new_custom_field #custom_field__name:last").parents("div.new_custom_field").find("input:checkbox").removeAttr("checked")
      $(this).parents("div.new_custom_field").find("select").change(function () {
        if ($(this).val() === "File" || $(this).val() === "Location" || $(this).val() === "Date") {
          $(this).parents("div.new_custom_field").find("input:checkbox").removeAttr("checked")
          $(this).parents("div.new_custom_field").find("#label_check").hide()
        } else {
          $(this).parents("div.new_custom_field").find("#label_check").show()
        }
      })
      $(this).val("").parents("div.new_custom_field").find("select").children(":first").attr("selected", "selected").change()
    })
    $("#new_custom_class_dialog").modal("show")
  }

  addColumn(event) {
    event.preventDefault()

    const modalDialog = $("#field_add_dialog")
    $("#field_add input:text").each(function () {
      $(this).val("")
      const parentEl = $(this).parents("div.new_custom_col")
      parentEl.find("label").find("input:checkbox").removeAttr("checked")
      parentEl.find("select").children(":first").attr("selected", "selected")
      parentEl.find("select").change(function () {
        if ($(this).val() === "File" || $(this).val() === "Location" || $(this).val() === "Date") {
          parentEl.find("input:checkbox").removeAttr("checked")
          parentEl.find("#label_check").hide()
        } else {
          parentEl.find("#label_check").show()
        }
      })
      parentEl.find("select").children(":first").attr("selected", "selected").change()
    })

    modalDialog.find(".modal-title").html(`Add field to "${this.classNameValue}"`)
    modalDialog.modal("show")
  }

  addRecord(event) {
    event.preventDefault()

    $("#record_add .bar").width("0%")
    $("#record_add .controls").children(":not(#new_record_user_id)").each(function () {
      $(this).parents("form").find(".inputFile, .fileName").val("")
    })

    const self = this
    $.getJSON(`${this.customClassesPathValue}/new_record?class_id=${this.classIdValue}`, (data) => {
      self.addCodem.setValue(self.#formatJSON(data.attrs, "", data.comments))

      const modalDialog = $("#record_add_dialog")

      $(modalDialog).off("show.bs.modal.customClassesIndex").on("show.bs.modal.customClassesIndex", function () {
        $(this).off("click.customClassesIndex", ".btn-group button")
        $(this).on("click.customClassesIndex", ".btn-group button", function () {
          $(this).addClass("active")
          $(this).siblings().removeClass("active")
        })
      })

      $(".new-btn").off("mouseup.customClassesIndex").on("mouseup.customClassesIndex", function () { $(this).blur() })

      modalDialog.modal("show")
      modalDialog.find(".modal-title").html(`Add record to "${self.classNameValue}"`)

      modalDialog.find("#set_permissions").off("click.customClassesIndex").on("click.customClassesIndex", function () {
        $(this).toggleClass("active")
        if ($(this).hasClass("active")) {
          $(modalDialog).find(".permissions_setting-wrap").show()
        } else {
          $(modalDialog).find(".permissions_setting-wrap").hide()
        }
      })

      $(modalDialog).find("tr.trow").each(function () {
        const action = $(this).attr("id")
        if (action !== "read") $(this).find("select").val(self.aclOwnerValue)
        if (action === "read") $(this).find("select").val(self.aclOpenValue)
        self.#permissionsSetting(this)
      })

      $("#simple_add").off("click.customClassesIndex").on("click.customClassesIndex", () => {
        $("#record_add_advanced").hide()
        $("#record_add_simple").show()
      })
      $("#advanced_add").off("click.customClassesIndex").on("click.customClassesIndex", () => {
        $("#record_add_simple").hide()
        $("#record_add_advanced").show()
        self.addCodem.setValue(self.#formatJSON(data.attrs, "", data.comments))
      })

      self.addCodem.refresh()
    })
  }

  editRecord(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.recordId
    this.#doEditRecord(id)
  }

  editPermissions(event) {
    event.preventDefault()

    const self = this
    $.getJSON(`${this.customClassesPathValue}/class_acl?class_id=${this.classIdValue}`, (data) => {
      const modalDialog = $("#edit_permissions_dialog")
      modalDialog.find(".modal-title").html(`Edit general permissions in "${self.classNameValue}"`)
      modalDialog.modal("show")

      $('[data-toggle="tooltip"]').tooltip()

      $("#edit_permissions").find("tr.trow").each(function () {
        const action = $(this).attr("id")
        if ($.isEmptyObject(data.acl)) {
          const mode = (action === "read" || action === "create") ? "open" : "owner"
          const aclMap = { open: self.aclOpenValue, owner: self.aclOwnerValue }
          $(this).find("select").val(aclMap[mode])
        } else {
          const accessType = $(data.acl).attr(action)
          if (accessType.primary) {
            $(this).find("input:checkbox").attr("checked", "checked")
          }
          $(this).find("select").val(accessType.access)
          $(this).find(".groups").val(accessType.users_groups)
          $(this).find(".ids").val(accessType.users_ids)
        }
        self.#permissionsSetting(this)
      })
    })
  }

  removeColumn(event) {
    event.preventDefault()

    const modalDialog = $("#field_remove_dialog")
    modalDialog.find(".modal-title").html(`Remove field in "${this.classNameValue}"`)
    modalDialog.modal("show")
  }

  removeClass(event) {
    event.preventDefault()

    const modal = $("#confirmation_remove_class")
    modal.find("#remove_class_confirmation").val("")
    modal.modal("show")
    modal.one("shown.bs.modal.customClassesIndex", () => {
      modal.find("#remove_class_confirmation").trigger("focus")
    })
  }

  confirmRemoveClass(event) {
    event.preventDefault()

    const confirmation = "delete the class with all contents"
    const text = $("#remove_class_confirmation").val()?.trim()
    if (text !== confirmation) {
      alert(`Please enter exactly: "${confirmation}"`)
      return
    }

    $("#confirmation_remove_class").modal("hide")
    $.delete(`${this.customClassesPathValue}/destroy`, { class_id: this.classIdValue }, () => {
      location.reload()
    })
  }

  removeData(event) {
    if (event) event.preventDefault()

    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const availableCheckboxes = $(`input[name^='${groupName}']`)
    const allCheckboxes = checkboxes.length === availableCheckboxes.length

    if (!availableCheckboxes.length) return
    if (!checkboxes.length) { alert("Please select at least one item"); return }
    if (!confirm("Are you sure? All selected items will be removed")) return

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.post(this.removeDataPathValue, { item_ids: ids }, () => {
      const settings = this.oTable.settings()[0]
      if (allCheckboxes && (settings._iRecordsDisplay - settings._iDisplayStart <= settings._iDisplayLength)) {
        this.oTable.page("previous").draw(false)
      } else {
        this.oTable.draw(false)
      }
    })

    if (allCheckboxes) $("input#check-all").click()
  }

  // -- Private ----------------------------------------------------------------

  #bindPermissionsAccessSelectors() {
    const ops = ["create", "read", "update", "delete"]
    ops.forEach((op) => {
      $(`#permissions_${op}_access`).off("change.customClassesIndex").on("change.customClassesIndex", function () {
        $(`#permissions_${op}_ids`).hide()
        $(`#permissions_${op}_groups`).hide()
        if ($(this).val() === "4") $(`#permissions_${op}_ids`).show()
        if ($(this).val() === "3") $(`#permissions_${op}_groups`).show()
      })
    })
  }

  #showError(message, element) {
    this.#hideMessages()
    const errorBlock = element.find(".form-results-errors")
    if (errorBlock.length) {
      errorBlock.find(".content").html(message)
      errorBlock.fadeIn()
    }
  }

  #hideMessages() {
    if (typeof hide_messages === "function") hide_messages()
  }

  #deleteFile() {
    $(".delete_icon").off("click.customClassesIndex").on("click.customClassesIndex", (event) => {
      event.preventDefault()
      const href = event.currentTarget.querySelector("a")?.getAttribute("href")
      if (!href) return
      if (!confirm("Are you sure you want to delete this file?")) return

      $.get(href)
        .done(() => { window.location.reload() })
        .fail((response) => { check_auth_status(response.status) })
    })
  }

  #submitPermissions(form) {
    let fieldsEmpty = false
    form.find(".row").each(function () {
      if ($(this).find("select").val() === "open_for_groups" && $(this).find("input.groups").val() === "") {
        fieldsEmpty = true
      } else if ($(this).find("select").val() === "open_for_users_ids") {
        if ($(this).find("input.ids").val() === "") fieldsEmpty = true
      }
    })
    return !fieldsEmpty
  }

  #dialogsSubmitHandlers() {
    $.each(["new_custom_class", "field_add"], (_i, v) => {
      $(`#${v}_dialog`).find("input:submit").on("click.customClassesIndex", (event) => {
        event.preventDefault()
        $(`#${v}`).submit()
      })
    })
  }

  #bindMainPage() {
    $("#record_add").validate()

    function checkDateValue(ct) {
      $(":focus").val(ct.dateFormat("Y-m-d H:i:00"))
      $(":focus").rules("add", { isDate: true, messages: { isDate: "DateTime is invalid." } })
    }

    $("input[placeholder='Date']").datetimepicker({
      format: "Y-m-d H:i:s",
      step: 1,
      onSelectDate(ct) { checkDateValue(ct) },
      onSelectTime(ct) { checkDateValue(ct) },
    })

    const codemOptions = {
      mode: { name: "javascript", json: true },
      json: true,
      lineNumbers: true,
      matchBrackets: true,
      theme: "default",
    }

    if (document.getElementById("json_edit") != null) {
      this.editCodem = CodeMirror.fromTextArea(document.getElementById("json_edit"), codemOptions)
    }
    if (document.getElementById("json_add") != null) {
      this.addCodem = CodeMirror.fromTextArea(document.getElementById("json_add"), codemOptions)
    }

    if (document.getElementById("custom_table") != null) {
      this.#initDataTable()
    }

    // Bind even when there is no table yet (empty state) so "Create class" uses AJAX
    // instead of a full-page POST that dumps JSON into the browser.
    this.#bindAjaxForms()

    $(".form-results-errors .close").on("click.customClassesIndex", function (event) {
      event.preventDefault()
      event.stopPropagation()
      $(this).closest(".form-results-errors").css("display", "none")
    })

    $(".modal").on("hide.bs.modal.customClassesIndex", () => {
      $(".form-results-errors").fadeOut()
    })

    this.#dialogsSubmitHandlers()
    this.#handleCheckboxChanges()
  }

  #initDataTable() {
    const self = this

    this.oTable = createTurboDataTable("#custom_table", {
      dom: 'lr<"processing-file">ftip<"toolbar">',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      order: [1, "asc"],
      scrollX: true,
      language: { searchPlaceholder: "ID, User ID" },
      ajax: {
        url: `${this.customClassesPathValue}/data?class_id=${this.classIdValue}`,
        type: "POST",
        timeout: 30000,
        dataType: "json",
        error: this.#handleAjaxError,
      },
      footerCallback() { $("#check-all").attr("checked", false) },
      initComplete() {
        $("#loading").hide()
        $("#workspace").show()
      },
      rowCallback(row, data) { $(row).attr("id", data[0]) },
      stateLoadParams(_settings, data) { data.start = 0 },
      drawCallback() { self.#deleteFile() },
      columnDefs: [
        {
          targets: 0,
          orderable: false,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" id="check--dialogs ${cellData}" class="table-checkbox-row" name="item_ids[]" value="${cellData}"/> <label for="check--dialogs ${cellData}"></label>`,
            )
          },
        },
        {
          targets: 1,
          createdCell(cell, cellData) {
            $(cell).html(
              `<a href="#" data-action="click->custom-classes--index#editRecord" data-record-id="${cellData}">${cellData}</a>`,
            )
          },
        },
        {
          targets: 2,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="${this.usersEditPathValue}/edit/${cellData}">${dataTruncate(cellData, 15)}</a>`,
            )
          },
        },
        {
          targets: [-1],
          createdCell(cell, cellData) {
            const createdAt = cellData.replace("<span style='white-space:nowrap'>", "").replace("</span>", "")
            $(cell).html(createdAt ? moment(createdAt).format() : "")
          },
        },
      ],
    })

    const searchBox = $("#custom_table_filter input")
    searchBox.unbind()
    searchBox.bind("input", (e) => {
      if (e.target.value.length > 0) this.oTable.search(e.target.value).draw()
      if (e.target.value === "") this.oTable.search("").draw()
    })

    $("#custom_table_filter input").on("autocompleteselect", (_e, ui) => {
      this.oTable.search(ui.item.value.replace("...", "")).draw()
    })

    $("div.class_select").html($("#class_select").html())

    if ($("#reader").val() === "false") {
      $("div.processing-file").html($("#processing-file").html())
      $("#custom_table_wrapper div.toolbar").html(
        '<br><br><a href="#" class="remove" data-action="click->custom-classes--index#removeData">Remove selected</a>',
      )
    }

    $(".class_select #class_name").off("change.customClassesIndex").on("change.customClassesIndex", () => {
      $(".class_select #class_name").attr("disabled", true)
      document.location = `${this.customClassesPathValue}?class_id=${$(".class_select #class_name").val()}`
    })

    $(".inputFile:not(.import_csv)").on("change.customClassesIndex", (e) => {
      if (e.target.files[0].size > this.fileSizeLimitValue) {
        $(e.target).val("")
        $(e.target).parent().find("input[type='text']").val("")
        alert(`The file you are trying to upload is too large. Max file size is ${this.fileSizeLimitMbValue} Mbytes`)
      }
    })
  }

  #bindAjaxForms() {
    this.ajaxFormSelectors = "#new_custom_class, #field_add, #field_remove, #record_add_simple form, #record_add_advanced form, #record_edit_simple form, #record_edit_advanced form, #edit_permissions"
    const self = this

    $(this.ajaxFormSelectors).each(function () {
      const form = $(this)
      let method = form.find('input[name = "_method"]').val()
      method = method === undefined ? "POST" : method

      form.ajaxForm({
        dataType: "json",
        type: method,
        uploadProgress(_event, _position, _total, percentComplete) {
          form.find(".bar").width(`${percentComplete}%`)
        },
        beforeSubmit() {
          remove_flash()
          self.#waitMessage(form)
          if (!self.#submitPermissions(form)) {
            self.#showError("Permissions fields can not be blank", form.parents(".modal-body"))
            self.#endWaitMessage(form)
            scrollToContainer()
            return false
          }
        },
        success(response) {
          if (response.success) {
            $(`#${form.attr("id")}_dialog`).modal("hide")
            if (["record_add", "record_edit", "edit_permissions"].indexOf(form.attr("id")) >= 0) {
              self.oTable.draw(false)
            } else if (["new_custom_class"].indexOf(form.attr("id")) >= 0) {
              $(location).attr("href", `${self.customClassesPathValue}?class_id=${response.class_id}`)
            } else {
              window.location.reload()
            }
          } else {
            self.#showError(response.message, form.parents(".modal-body"))
          }
          self.#endWaitMessage(form)
          scrollToContainer()
        },
        error(response) {
          self.#showError("An error occurred during request", form.parents(".modal-body"))
          self.#endWaitMessage(form)
          scrollToContainer()
          check_auth_status(response.status)
        },
      })
    })
  }

  #unbindAjaxForms() {
    if (!this.ajaxFormSelectors) return
    $(this.ajaxFormSelectors).each(function () {
      try { $(this).ajaxFormUnbind() } catch (_e) { /* already unbound */ }
    })
  }

  #doEditRecord(id) {
    $("#record_edit .bar").width("0%")
    $("#record_edit .controls").children().each(function () {
      $(this).val("").children(".inputFile, .fileName").val("")
    })

    const self = this
    $.getJSON(`${this.customClassesPathValue}/get?id=${id}`, (data) => {
      $("#record_edit #record_id").val(data.attrs._id)
      $("#record_edit .params").each(function () {
        let value = $(data.attrs).attr($(this).data("param"))
        if (value != null) {
          if ($(this).data("array")) value = JSON.stringify(value)
          $(this).val(value.toString())
        }
      })

      const modalDialog = $("#record_edit_dialog")

      $(modalDialog).off("show.bs.modal.customClassesIndex").on("show.bs.modal.customClassesIndex", function () {
        $(this).off("click.customClassesIndex", ".btn-group button")
        $(this).on("click.customClassesIndex", ".btn-group button", function () {
          $(this).addClass("active")
          $(this).siblings().removeClass("active")
        })
        self.editCodem.refresh()
      })

      $(modalDialog).off("shown.bs.modal.customClassesIndex").on("shown.bs.modal.customClassesIndex", () => {
        self.editCodem.setValue(self.#formatJSON(data.attrs, "", data.comments))
        self.editCodem.refresh()
      })

      $(".new-btn").off("mouseup.customClassesIndex").on("mouseup.customClassesIndex", function () { $(this).blur() })

      modalDialog.find(".modal-title").html(`Edit record in "${self.classNameValue}"`)
      modalDialog.modal("show")

      modalDialog.find("#set_permissions").off("click.customClassesIndex").on("click.customClassesIndex", function () {
        $(this).toggleClass("active")
        if ($(this).hasClass("active")) {
          $(modalDialog).find(".permissions_setting-wrap").show()
        } else {
          $(modalDialog).find(".permissions_setting-wrap").hide()
        }
      })

      $(modalDialog).find("tr.trow").each(function () {
        const action = $(this).attr("id")
        if ($.isEmptyObject(data.acl)) {
          if (action === "read") {
            $(this).find("select").val(self.aclOpenValue)
          } else {
            $(this).find("select").val(self.aclOwnerValue)
          }
        } else {
          const accessType = $(data.acl).attr(action)
          $(this).find("select").val(accessType.access)
          if (accessType.users_groups) $(this).find(".groups").val(accessType.users_groups.join(","))
          if (accessType.users_ids) $(this).find(".ids").val(accessType.users_ids.join(","))
        }
        self.#permissionsSetting(this)
      })

      $("#simple_edit").off("click.customClassesIndex").on("click.customClassesIndex", () => {
        $("#record_edit_advanced").hide()
        $("#record_edit_simple").show()
      })
      $("#advanced_edit").off("click.customClassesIndex").on("click.customClassesIndex", () => {
        $("#record_edit_simple").hide()
        $("#record_edit_advanced").show()
        self.addCodem.setValue(self.#formatJSON(data.attrs, "", data.comments))
        self.editCodem.refresh()
      })
    })
  }

  #permissionsSetting(row) {
    $(row).each(function () {
      const select = $(this).find("select")
      addIdsAndGroups(select)
    })
    $(row).find("select").change(function () {
      addIdsAndGroups(this)
    })

    function addIdsAndGroups(select) {
      const currentRow = $(select).addClass("active").closest("tr")
      currentRow.find("input:not(:checkbox)").hide()
      switch ($("option:selected", $(select)).text()) {
        case "Open for groups":
          currentRow.find(".groups").show()
          break
        case "Open for users ids":
          currentRow.find(".ids").show()
          break
      }
    }
  }

  #waitMessage(form) {
    $(form).find(":submit").addClass("loading_submit").enable(false).next(".inline-loading").show()
  }

  #endWaitMessage(form) {
    $(form).find(":submit").removeClass("loading_submit").enable(true).next(".inline-loading").hide()
  }

  #handleCheckboxChanges() {
    $("#custom_table_wrapper").on("change.customClassesIndex", ".table-checkbox-row", function () {
      const isChecked = $(this).prop("checked")
      const row = $(this).closest("tr")
      row.toggleClass("selected-row", isChecked)

      const selectedCount = $(".table-checkbox-row:checked").length
      const totalCount = $(".table-checkbox-row").length
      $("#check-all").prop("checked", selectedCount > 0 && selectedCount === totalCount)
    })

    $("#check-all").on("change.customClassesIndex", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-row").prop("checked", isChecked).closest("tr").toggleClass("selected-row", isChecked)
    })
  }

  #destroyCheckboxDelegation() {
    $("#custom_table_wrapper").off("change.customClassesIndex")
    $("#check-all").off("change.customClassesIndex")
    $(".delete_icon").off("click.customClassesIndex")
  }

  #handleAjaxError(xhr) {
    if (xhr.status === 404) {
      document.location.href = document.location.pathname
    }
  }

  #formatJSON(oData, sIndent, comments) {
    if (arguments.length < 2) sIndent = ""
    const sIndentStyle = "  "
    const sDataType = realTypeOf(oData)

    let sHTML
    if (sDataType === "array") {
      if (oData.length === 0) return "[]"
      sHTML = "["
    } else {
      let iCount = 0
      $.each(oData, () => { iCount++; return undefined })
      if (iCount === 0) return "{}"
      sHTML = "{"
    }

    let itemCount = 0
    $.each(oData, (sKey, vValue) => {
      if (itemCount > 0) sHTML += ","

      const tabDistance = 24 - (sKey.length + 5)
      const roundTabDistance = tabDistance % 4 === 0 ? tabDistance / 4 : (tabDistance + 4 - (tabDistance % 4)) / 4
      const tabstr = tabTimes(roundTabDistance)

      if (sDataType === "array") {
        sHTML += `\n${sIndent}${sIndentStyle}`
      } else {
        if (comments && comments[sKey]) {
          sHTML += `\n\n${sIndent}${sIndentStyle}${comments[sKey]}`
        }
        sHTML += `\n${sIndent}${sIndentStyle}"${sKey}":`
      }

      switch (realTypeOf(vValue)) {
        case "array":
        case "object": {
          const addTabs = sKey.length % 4 === 0 ? sKey.length / 4 : (sKey.length + 4 - (sKey.length % 4)) / 4
          sHTML += tabstr + this.#formatJSON(vValue, tabstr + tabTimes(addTabs) + sIndentStyle)
          break
        }
        case "boolean":
        case "number":
          sHTML += tabstr + vValue.toString()
          break
        case "null":
          sHTML += `${tabstr}null`
          break
        case "string": {
          const escaped = vValue.replace(/"/g, '\\"').replace(/\n/g, "\\n")
          sHTML += `${tabstr}"${escaped}"`
          break
        }
        default:
          sHTML += `${tabstr}TYPEOF: ${typeof vValue}`
      }

      itemCount++
    })

    if (sDataType === "array") {
      sHTML += `\n${sIndent}${sIndentStyle}]`
    } else {
      sHTML += `\n${sIndent}}`
    }

    return sHTML

    function tabTimes(tabt) {
      let str = ""
      for (let i = 0; i < tabt; i++) str += "\t"
      return str
    }

    function realTypeOf(v) {
      if (typeof v === "object") {
        if (v === null) return "null"
        if (Array.isArray(v)) return "array"
        if (v instanceof Date) return "date"
        if (v instanceof RegExp) return "regex"
        return "object"
      }
      return typeof v
    }
  }
}
